import { gql } from '@apollo/client'

export type {
  AssignCommercialExecutiveGoal,
  AssignCommercialExecutiveGoalVariables,
  AssignCommercialExecutiveGoal_assignCommercialExecutiveGoal_AssignGoalMutationResponse_assignedGoal_OrganizationUserGoal as AssignedGoal,
} from './types/index.graphql'

export const ASSIGN_COMMERCIAL_EXECUTIVE_GOAL = gql`
  mutation AssignCommercialExecutiveGoal($assignGoalDTO: AssignGoalInput!) {
    assignCommercialExecutiveGoal(assignGoalDTO: $assignGoalDTO) {
      success
      assignedGoal {
        id
        yearMonth
        goal
        contributionGoal
      }
    }
  }
`
